import { Icon, Typography } from 'shared/ui'
import styles from 'widgets/ConversationMessages/ui/EmptryConversationsState/styles.module.scss'

export const SelectConversationState = () => (
  <div className={styles.wrap}>
    <div className={styles.icon}>
      <Icon icon={'conversation'} fontSize={24} />
    </div>
    <Typography
      variant={'body-rg-medium'}
      tag='div'
      marginBottom={'4px'}
      ariaLabel={'SelectAConversation'}
    >
      Select a conversation
    </Typography>
    <Typography variant={'body-md-regular'} className={'tertiary'} ariaLabel={'description'}>
      Messages and activity will appear here
    </Typography>
  </div>
)
